import ExceptionEntity from "../../../../../domain/entities/ExceptionEntity";
import { Either, left, right } from "fp-ts/lib/Either";
import { Auth } from "aws-amplify";
import Constants, { ConstantsName } from "../../../../../constants/Constants";
import di from "../../../../../di/DependencyInjection";

const extractEmailsAndMessages = (data: any) => {
    const result: any = [];
    data.details.forEach((detail: any) => {
        const userInfo = detail[0]; // Accessing the user information object
        if (userInfo && userInfo.data && userInfo.data.email && userInfo.message && detail[1] !== 200) {
            result.push({
                email: userInfo.data.email,
                message: userInfo.message
            });
        }
    });
    return result;
};

const UpdateUsersApiImpl = async (data: any[]): Promise<Either<ExceptionEntity, string>> => {
    
    try {
        const baseUrl = di.get<Constants>(ConstantsName).HOST_API_USERS_URL;
        const session = await Auth.currentSession();
        const token = session.getIdToken().getJwtToken();

        const response = await fetch(`${baseUrl}/usersetup`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token,
            },
            body: JSON.stringify(data),
        });

        const datatest = await response.json();

        if (response.status === 207) {
            const emailsAndMessages = extractEmailsAndMessages(datatest);
            const usersFilterd = emailsAndMessages.map((user: any) => user.email).join(",");
            throw new Error(`Error updating some users: ${usersFilterd}`);
        }

        if (!response.ok) {
            const message = datatest?.message || datatest?.details?.[0]?.[0]?.message || `Update failed with status ${response.status}`;
            throw new Error(message);
        }

        return right(datatest);
        
    } catch (error: any) {
        const exception: ExceptionEntity = {message: error.message};
        
        return left(exception);
    }

}

export default UpdateUsersApiImpl;
